export var FeatureStatus;
(function (FeatureStatus) {
    FeatureStatus["NO_UPDATE"] = "NO_UPDATE";
    FeatureStatus["HAS_UPDATE"] = "HAS_UPDATE";
    FeatureStatus["UPDATE_DISMISSED"] = "UPDATE_DISMISSED";
    FeatureStatus["UPDATE_VIEWED"] = "UPDATE_VIEWED";
})(FeatureStatus || (FeatureStatus = {}));
